"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const storeLocatorInputs = [
  {
    name: "defaultLatitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "defaultLongitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "storesLimit",
    type: "number",
    defaultValue: 0,
  },
  {
    name: "filtersEnabled",
    type: "boolean",
    defaultValue: true,
  },
  {
    name: "defaultZoom",
    type: "number",
    defaultValue: 15,
  },
  {
    name: "storeLocatorDetailsPageUrl",
    type: "url",
  },
  {
    name: "filtersTranslations",
    type: "list",
    subFields: [
      {
        name: "filterKey",
        type: "string",
        required: true,
      },
      {
        name: "translatedFilterKey",
        type: "string",
        required: true,
      },
    ],
  },
] as const satisfies Inputs;

export const StoreLocatorComponent: RegisteredComponent = {
  name: "StoreLocator",
  component: dynamic(
    async () =>
      withValidation(
        storeLocatorInputs,
        (await import("./StoreLocator")).StoreLocator,
        "StoreLocator"
      ),
    { ssr: false }
  ),
  inputs: storeLocatorInputs,
};
